import React from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-scroll";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../styleConstants";

const styles = {
  activeLink: {
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.themeBlue
  },
  container: {
    margin: "1rem 0",
    color: styleConstants.colors.themeBlueMedium,
    "&:hover": {
      backgroundColor: "transparent"
    },
    cursor: "pointer"
  },
  link: {
    textDecoration: "none",
    transition: "color 0.25s ease-in",
    "&:hover": {
      color: styleConstants.colors.themeBlue
    }
  }
};

const NavigationItem = props => (
  <div className={props.classes.container}>
    <Link
      to={props.linkTo}
      offset={-144}
      smooth={true}
      spy={true}
      hashSpy={true}
      className={props.classes.link}
      activeClass={props.classes.activeLink}>
      <span>{props.label}</span>
    </Link>
  </div>
);

NavigationItem.propTypes = {
  label: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired
};

export default withStyles(styles)(NavigationItem);
